
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18.75 10.5V6.75h4.5V24a2.252 2.252 0 01-3 2.122M24.75 6.75h-7.5M9.75 3.75h6"}}),_c('path',{attrs:{"d":"M14.25 11.4V3.75h-3v7.65a7.5 7.5 0 103 0h0zM20.1 20.25H5.4"}})])])
          )
        }
      }
    